import { Form, Input, Table } from 'antd';
import { SCROLL_Y } from 'constants/table';
import React from 'react';
import { requiredRule } from 'utils/forms/validationRules';

export default function BccPaymentsRefundTableForm({ loading, drawer }) {
  const columsReportRows = [
    {
      title: 'ИИН',
      key: 'iin',
      dataIndex: 'iin',
      render: (text, _, i) => (
        <Form.Item name={['iin', i]} initialValue={text} rules={[requiredRule]}>
          <Input />
        </Form.Item>
      ),
    },
    {
      title: 'Фамилия',
      key: 'fm',
      dataIndex: 'fm',
      render: (text, _, i) => (
        <Form.Item name={['fm', i]} initialValue={text} rules={[requiredRule]}>
          <Input />
        </Form.Item>
      ),
    },
    {
      title: 'Имя',
      key: 'nm',
      dataIndex: 'nm',
      render: (text, _, i) => (
        <Form.Item name={['nm', i]} initialValue={text} rules={[requiredRule]}>
          <Input />
        </Form.Item>
      ),
    },
    {
      title: 'Отчество',
      key: 'ft',
      dataIndex: 'ft',
      render: (text, _, i) => (
        <Form.Item name={['ft', i]} initialValue={text}>
          <Input />
        </Form.Item>
      ),
    },
    {
      title: 'Дата рождения',
      key: 'dt',
      dataIndex: 'dt',
      render: (text, _, i) => (
        <Form.Item name={['dt', i]} initialValue={text} rules={[requiredRule]}>
          <Input />
        </Form.Item>
      ),
    },
    {
      title: 'Период',
      key: 'period',
      dataIndex: 'period',
      render: (text, _, i) => (
        <Form.Item initialValue={text} name={['period', i]}>
          {text}
        </Form.Item>
      ),
    },
    {
      title: 'Сумма',
      key: 'amount',
      dataIndex: 'amount',
      render: (text, _, i) => (
        <Form.Item initialValue={text} name={['amount', i]}>
          {text}
        </Form.Item>
      ),
    },
  ];

  return (
    <Table
      columns={columsReportRows}
      tableLayout="fixed"
      pagination={false}
      dataSource={[...drawer.state.activeRecord.reportRows]}
      loading={loading}
      scroll={{ x: 1300, y: SCROLL_Y }}
      rowKey="id"
    />
  );
}
